export const HmiType = {
  registration: {
    daas: 'hmi/registration/daas',
    baas: 'hmi/registration/baas',
    hatOwner: 'hmi/registration/hatOwner',
  },
  permissions: {
    daas: 'hmi/permissions/daas',
    baas: 'hmi/permissions/baas',
  },
  login: {
    daas: 'hmi/login/daas',
    baas: 'hmi/login/baas',
  },
};
